import * as api from '../api';

const fetchCurrentSessionActions = api.fetchActions('auth', 'fetch-current-session');
const verifyCurrentSessionActions = api.fetchActions('auth', 'verify-current-session');
const createEtoSessionActions = api.fetchActions('auth', 'create-eto-session');

export const actionTypes = {
  SET_SESSION: 'auth.set-session',
  ...fetchCurrentSessionActions.actionTypes,
  ...verifyCurrentSessionActions.actionTypes,
  ...createEtoSessionActions.actionTypes,
  INVALIDATE_CURRENT_SESSION: 'auth.invalidate-current-session',
  INVALIDATE_CURRENT_SESSION_UNOBTRUSIVE: 'auth.invalidate-current-session-unobtrusive',
};

export const fetchCurrentSession = () => api.getThunk('/setup/current-session', null, fetchCurrentSessionActions);
export const verifyCurrentSession = (token) => api.getThunk('/setup/eto-verify', {token}, verifyCurrentSessionActions);
export const createEtoSession = (enterpriseGuid, etoToken) => api.postThunk('/setup/eto-auth', { enterpriseGuid, etoToken }, createEtoSessionActions);

export function setSession(session) {
  return {
    type: actionTypes.SET_SESSION,
    session
  }
}

export function getCurrentSessionFromSecureToken(secureToken) {
  return (dispatch) => {
    dispatch(setBearerAuth(secureToken));
    return dispatch(fetchCurrentSession());
  }
}

export function verifySession(secureToken) {
  return (dispatch) => {
    dispatch(setBearerAuth(secureToken));
    return dispatch(verifyCurrentSession(secureToken));
  }
}

export function invalidateCurrentSession() {
  return {
    type: actionTypes.INVALIDATE_CURRENT_SESSION
  }
}

export function invalidateCurrentSessionUnobtrusive() {
  return {
    type: actionTypes.INVALIDATE_CURRENT_SESSION_UNOBTRUSIVE
  }
}

function setBearerAuth(secureToken) {
  return (dispatch) => {
    api.config.unauthorizedGetNotifier = () => {
      dispatch(invalidateCurrentSession());
    }
    api.config.unauthorizedPostNotifier = () => {
      dispatch(invalidateCurrentSessionUnobtrusive());
    }
  }
}



// WEBPACK FOOTER //
// src/auth/auth.actions.js